/**
 * 🔗 URLs del Ecommerce por subdominio (estilo Shopify)
 *
 * - dulti.smarty.lat → Tenant "dulti"
 * - dulti.smarty.local:8080 → Desarrollo
 */

import { getTenantSubdomain, isLocalhost } from '@/lib/domain';
import { devLog } from '@/lib/utils';
import { STOREFRONT_ROOT_DOMAIN } from '@/config/app-domains.config';

function getCurrentSubdomain(): string | null {
  if (typeof window === 'undefined') return null;
  if (isLocalhost(window.location.hostname)) return null;
  return getTenantSubdomain();
}

/**
 * Construye la URL PÚBLICA de la tienda: `https://{subdomain}.smartylat.com{path}`.
 *
 * SIEMPRE producción, también en dev. La tienda se sirve desde Cloudflare Workers
 * (dominio dedicado `smartylat.com`), NO desde el dev server del admin. Antes esto
 * devolvía `{sub}.smarty.local:8085` en dev → NXDOMAIN (ahí corre el admin, no el
 * storefront) y en prod `{sub}.smarty.lat` (el dominio corporativo, no el de
 * tiendas). Ver docs/adr/0001-ruteo-de-storefronts-por-tenant.md
 */
export function getEcommerceUrl(path: string = '/', subdomain?: string | null): string {
  const currentSubdomain = subdomain || getCurrentSubdomain();

  if (!currentSubdomain) {
    devLog.warn('⚠️ Intento de construir URL de ecommerce sin subdominio');
    return '';
  }

  if (currentSubdomain === 'admin' || currentSubdomain === 'app') {
    devLog.warn('⚠️ Subdominio reservado para panel:', currentSubdomain);
    return '';
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `https://${currentSubdomain}.${STOREFRONT_ROOT_DOMAIN}${normalizedPath}`;
}

export function getEcommerceBaseUrl(subdomain?: string | null): string {
  return getEcommerceUrl('', subdomain);
}
